import { render, staticRenderFns } from "./DefaultMailNewUser.vue?vue&type=template&id=83adc628&"
import script from "./DefaultMailNewUser.vue?vue&type=script&lang=js&"
export * from "./DefaultMailNewUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports